module.exports = __webpack_public_path__ + "images/create-first-board/card-drag/it-card-drag.9e24ebbe69faf11b9fb7.gif";